<template>
    <div>
        <!-- Snackbar -->
        <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card>
            <v-card-title class="toolbar">
                Map Route To Students
                <v-spacer></v-spacer>
                <v-btn small class="mr-5" color="white" @click="openDialogForAddStudents()" :loading="loader">
                    <v-icon small color="black">mdi-plus</v-icon>
                    <span class="btn-text">Add Route & Vehicle</span>
                </v-btn>
                <v-btn small color="white" @click="openDialogForimportStudents()" :loading="loader">
                    <v-icon small color="black">mdi-arrow-down-box</v-icon>
                    <span class="btn-text">Import Students</span>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-row justify="center" class="mt-2">
                    <!-- Route Dropdown -->
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete v-model="selected_route" :items="route_list" item-text="name" item-value="id"
                            outlined rounded required clearable>
                            <template #label>
                                Route<span style="color: red;">*</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete v-model="selected_vehicle" :items="vehicle_list" item-text="name" item-value="id"
                            outlined rounded required clearable>
                            <template #label>
                                Vehicle<span style="color: red;">*</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>

                <v-row justify="center" align="center">
                    <v-btn rounded class="button" :loading="loader" @click="getAllReport">
                        Fetch
                    </v-btn>
                </v-row>
            </v-card-text>

            <!-- Learner Table -->
            <div v-if="learner_list.length > 0" id="my-table-id" class="ma-3">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Map Route To Students</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field class="pr-5 no-display" background-color="white" v-model="search"
                        append-icon="mdi-magnify" label="Search by Student Name or Registration Number" single-line
                        hide-details></v-text-field>
                    <v-btn small color="success" @click="exportData" :loading="loader">
                        <v-icon small color="white">mdi-export</v-icon>
                        <span class="btn-text">Export</span>
                    </v-btn>
                </v-toolbar>

                <v-data-table
                    class="elevation-1 mytable"
                    :headers="headers"
                    :items="filteredList"
                    :items-per-page="10"
                    dense
                >
                    <!-- Edit -->
                    <template v-slot:item.edit="{ item }">
                        <v-icon small class="mr-2" @click="openEditDialog(item)" :loading="deleteloading">
                            edit
                        </v-icon>
                    </template>
                    <!-- Delete -->
                    <template v-slot:item.delete="{ item }">
                        <v-icon small @click="deleteItem(item)" color="red">
                            delete
                        </v-icon>
                    </template>
                </v-data-table>
            </div>

            <v-dialog v-model="dialogForAddStudents" width="1000px" persistent>
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-btn icon dark @click="dialogForAddStudents = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>Add Route To Students</v-toolbar-title>
                            </v-toolbar>

                            <v-row justify="center" class="mt-2">
                                <!-- Route Dropdown -->
                                <v-col cols="12" sm="6" md="3">
                                    <v-autocomplete
                                        v-model="selected_route_for_add_student"
                                        :items="route_list_without_all"
                                        item-text="name"
                                        item-value="id"
                                        outlined
                                        rounded
                                        required
                                        @change="fetchVehiclesForRoute"
                                    >
                                        <template #label>
                                            Route<span style="color: red;">*</span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-autocomplete
                                        v-model="selected_vehicle_for_add_student"
                                        :items="vehicle_list_for_add_student"
                                        item-text="name"
                                        item-value="id"
                                        outlined
                                        rounded
                                        required
                                    >
                                        <template #label>
                                            Vehicle<span style="color: red;">*</span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row justify="center" class="mt-2">
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field
                                        v-model="addprn"
                                        placeholder="Comma Separated PRN"
                                        outlined
                                        rounded
                                        required
                                    >
                                        <template #label>
                                            PRN<span style="color: red;">*</span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row justify="center" align="center">
                                <v-btn rounded class="button" :loading="loader" @click="saveLearnerRoute">
                                    Save
                                </v-btn>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogForimport" width="1000px" persistent>
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-btn icon dark @click="dialogForimport = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>Import Map Route To Students</v-toolbar-title>
                            </v-toolbar>

                            <v-row justify="center" class="mt-2">
                                <v-col cols="12" sm="2" md="2"></v-col>
                                <v-col cols="12" sm="6" md="5">
                                    <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/ImportMapRouteToStudent.csv">
                                        <v-btn color="black" rounded outlined class="ma-2 downbtn">
                                            Download CSV format
                                            <v-icon right dark>mdi-cloud-download</v-icon>
                                        </v-btn>
                                    </a>
                                </v-col>
                            </v-row>
                            <v-row justify="center" class="mt-2">
                                <v-col cols="12" sm="6" md="5">
                                    <v-file-input
                                        placeholder="CSV of Map route to student"
                                        prepend-icon="mdi-file"
                                        label="Import Map route to student"
                                        rounded
                                        dense
                                        flat
                                        outlined
                                        show-size
                                        v-model="file"
                                    ></v-file-input>
                                </v-col>
                            </v-row>

                            <v-row justify="center" align="center">
                                <v-btn rounded class="button" :loading="loader" @click="submitFile">
                                    Save
                                </v-btn>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-card>
            </v-dialog>

            <v-dialog v-model="faileddialog" width="1000px" persistent>
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-btn icon dark @click="faileddialog = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>Not Imported Map Route To Student</v-toolbar-title>
                            </v-toolbar>

                            <v-row class="mt-2" justify="center">
                                <v-data-table
                                    class="elevation-1 mytable"
                                    :headers="headers_for_failed"
                                    :items="failedlist"
                                    :items-per-page="10"
                                    dense
                                />
                            </v-row>

                            <v-row justify="center" align="center">
                                <v-btn rounded class="button" :loading="loader" @click="faileddialog = false">
                                    Close
                                </v-btn>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-card>
            </v-dialog>

            <v-dialog v-model="editDialog" max-width="500px" persistent>
                <v-card>
                    <v-toolbar class="toolbar" flat dense>
                        <v-btn icon dark @click="editDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Edit Learner Route</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="editForm">
                            <v-text-field
                                label="PRN"
                                v-model="editedItem.prn"
                                readonly
                                outlined
                                rounded
                                filled
                            ></v-text-field>
                            <v-select
                                label="Route"
                                v-model="editedItem.routeId"
                                :items="route_list_without_all"
                                item-text="name"
                                item-value="id"
                                outlined
                                rounded
                                required
                                @change="onRouteChange"
                            ></v-select>
                            <v-select
                                label="Vehicle"
                                v-model="editedItem.vehicleId"
                                :items="vehicle_list_for_edit"
                                item-text="name"
                                item-value="id"
                                outlined
                                rounded
                                required
                            ></v-select>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" @click="updateLearnerRoute">Save</v-btn>
                        <v-btn @click="editDialog = false" color="primary">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
    data() {
        return {
            dialogForAddStudents: false,
            deleteloading: false,
            faileddialog: false,
            selected_route_for_add_student: null,
            selected_vehicle_for_add_student: null,
            vehicle_list_for_add_student: [],
            vehicle_list_for_edit: [],
            currentVehicle: null, // Store the learner's current vehicle
            addprn: null,
            loader: false,
            color: "",
            snackbar: false,
            snackbar_msg: null,
            search: null,
            route_list: [],
            route_list_without_all: [],
            vehicle_list: [],
            vehicle_list_without_all: [],
            selected_route: null,
            selected_vehicle: null,
            learner_list: [],
            failedlist: [],
            file: null,
            dialogForimport: false,
            editDialog: false,
            editedItem: {},
            headers: [
                { text: "S.No", value: "count" },
                { text: "PRN", value: "prn" },
                { text: "Student Name", value: "student_name" },
                { text: "Standard", value: "standard" },
                { text: "Division", value: "division" },
                { text: "Route", value: "route" },
                { text: "Vehicle", value: "vehicle" },
                { text: "Mapped Date", value: "mapped_date" },
                { text: "Mapped By", value: "mapped_by" },
                { text: "Edit", value: "edit" },
                { text: "Delete", value: "delete" },
            ],
            headers_for_failed: [
                { text: "S.No", value: "sr_no" },
                { text: "PRN", value: "registration_number" },
                { text: "Route Number", value: "route_number" },
                { text: "Vehicle Number", value: "vehicle_number" },
                { text: "Reason", value: "reason" },
            ]
        };
    },

    mounted() {
        this.onload();
    },

    computed: {
        filteredList() {
            return this.learner_list.filter(item => {
                if (this.search) {
                    return (
                        (item.prn && item.prn.toLowerCase().includes(this.search.toLowerCase())) ||
                        (item.student_name && item.student_name.toLowerCase().includes(this.search.toLowerCase()))
                    );
                }
                return true;
            }).map(item => ({
                ...item,
                vehicle: item.vehicle || "Not Assigned",
                vehicleId: item.vehicleId || null
            }));
        }
    },

    methods: {
        async fetchVehiclesForRoute(routeId, isEdit = false) {
            if (!routeId) {
                if (isEdit) {
                    this.vehicle_list_for_edit = this.currentVehicle ? [this.currentVehicle] : [];
                    this.editedItem.vehicleId = this.currentVehicle ? this.currentVehicle.id : null;
                } else {
                    this.vehicle_list_for_add_student = [];
                    this.selected_vehicle_for_add_student = null;
                }
                return;
            }

            this.loader = true;
            try {
                const res = await axios.post("/TransportLearnerAttendance/getVehiclesByRoute", { routeId });
                if (res.data.msg === "200") {
                    const vehicles = res.data.vehicle_list || [];
                    if (isEdit) {
                        // Merge current vehicle with fetched vehicles, avoiding duplicates
                        this.vehicle_list_for_edit = this.currentVehicle && !vehicles.find(v => v.id === this.currentVehicle.id)
                            ? [this.currentVehicle, ...vehicles]
                            : vehicles;
                    } else {
                        this.vehicle_list_for_add_student = vehicles;
                    }
                    // Show error only on route change or save attempt, not on initial load
                    if (vehicles.length === 0 && !isEdit && this.vehicle_list_for_edit.length === 0) {
                        this.showSnackbar("error", "No vehicles found for this route");
                    }
                } else {
                    if (!isEdit) {
                        this.showSnackbar("error", res.data.msg || "Failed to fetch vehicles");
                    }
                    if (isEdit) {
                        this.vehicle_list_for_edit = this.currentVehicle ? [this.currentVehicle] : [];
                    } else {
                        this.vehicle_list_for_add_student = [];
                    }
                }
            } catch (error) {
                console.error("Error fetching vehicles:", error);
                if (!isEdit) {
                    this.showSnackbar("error", "Failed to fetch vehicles");
                }
                if (isEdit) {
                    this.vehicle_list_for_edit = this.currentVehicle ? [this.currentVehicle] : [];
                } else {
                    this.vehicle_list_for_add_student = [];
                }
            } finally {
                this.loader = false;
            }
        },

        onRouteChange(newRouteId) {
            if (!newRouteId) {
                this.vehicle_list_for_edit = this.currentVehicle ? [this.currentVehicle] : [];
                this.editedItem.vehicleId = this.currentVehicle ? this.currentVehicle.id : null;
                return;
            }
            this.fetchVehiclesForRoute(newRouteId, true);
        },

        openEditDialog(item) {
            this.currentVehicle = item.vehicleId && item.vehicle ? { id: item.vehicleId, name: item.vehicle } : null;
            this.editedItem = {
                ...item,
                vehicleId: item.vehicleId || null
            };
            this.vehicle_list_for_edit = this.currentVehicle ? [this.currentVehicle] : [];
            // Delay fetch to avoid immediate overwrite
            this.$nextTick(() => {
                this.fetchVehiclesForRoute(item.routeId, true);
            });
            this.editDialog = true;
        },

        async updateLearnerRoute() {
            if (!this.editedItem.routeId || !this.editedItem.vehicleId) {
                this.showSnackbar("error", "Please select both a route and a vehicle");
                return;
            }

            // Check if vehicle is valid for the selected route
            if (!this.vehicle_list_for_edit.find(v => v.id === this.editedItem.vehicleId)) {
                this.showSnackbar("error", "Selected vehicle is not available for this route");
                return;
            }

            try {
                const res = await axios.post("/TransportLearnerAttendance/updateLearnerRoute", {
                    id: this.editedItem.id,
                    routeId: this.editedItem.routeId,
                    vehicleId: this.editedItem.vehicleId
                });

                if (res.data.status === "success") {
                    this.onload();
                    this.showSnackbar("#4caf50", res.data.snackbar);
                    this.editDialog = false;
                } else {
                    this.showSnackbar("#b71c1c", res.data.msg || "Update failed");
                }
            } catch (error) {
                console.error(error);
                this.showSnackbar("#b71c1c", "Error updating learner route");
            }
        },

        deleteItem(item) {
            if (!confirm(`Are you sure you want to delete route for this ${item.student_name}?`)) {
                return;
            }

            this.deleteloading = true;
            axios
                .post("/TransportLearnerAttendance/deleteLearnerRoute", { id: item.id })
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.onload();
                        this.showSnackbar("#4caf50", res.data.snackbar || "Learner route deleted successfully");
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar || "Failed to delete learner route");
                    }
                })
                .catch((error) => {
                    console.error("Delete error:", error);
                    this.showSnackbar("#b71c1c", "Failed to delete learner route...");
                })
                .finally(() => {
                    this.deleteloading = false;
                });
        },

        submitFile() {
            if (this.file == null) {
                this.showSnackbar("error", "Please select the file..!");
                return;
            }

            this.loader = true;
            let formData = new FormData();
            formData.append("file", this.file);

            axios
                .post("TransportLearnerAttendance/importMapRouteToStudent", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("success", res.data.message || "File processed successfully!");
                        this.onload();
                        this.failedlist = (res.data.status && res.data.status.failedlist) ? res.data.status.failedlist : [];
                        if (this.failedlist.length > 0) {
                            this.faileddialog = true;
                        }
                        this.dialogForimport = false;
                    } else {
                        this.showSnackbar("error", res.data.message || "Error processing file.");
                        this.dialogForimport = false;
                    }
                })
                .catch(() => {
                    this.showSnackbar("error", "Upload failed!");
                })
                .finally(() => {
                    this.loader = false;
                });
        },

        openDialogForAddStudents() {
            this.selected_route_for_add_student = null;
            this.selected_vehicle_for_add_student = null;
            this.vehicle_list_for_add_student = [];
            this.addprn = null;
            this.dialogForAddStudents = true;
        },

        openDialogForimportStudents() {
            this.file = null;
            this.dialogForimport = true;
        },

        showSnackbar(color, msg) {
            this.snackbar = true;
            this.color = color;
            this.snackbar_msg = msg;
        },

        generatePdf() {
            try {
                const headersArr = this.headers;
                const exportData = this.filteredList.map((item, index) => {
                    const row = {};
                    headersArr.forEach(h => {
                        if (h.value === "count") {
                            row[h.value] = index + 1;
                        } else if (h.value === "mapped_date") {
                            row[h.value] = item[h.value]
                                ? new Date(item[h.value]).toLocaleDateString("en-GB")
                                : "-";
                        } else {
                            row[h.text] = (item[h.value] !== undefined && item[h.value] !== null) ? item[h.value] : "-";
                        }
                    });
                    return row;
                });

                const doc = new jsPDF();
                const columns = headersArr.map(h => ({
                    header: h.text,
                    dataKey: h.value
                }));

                doc.autoTable({
                    theme: "grid",
                    columns: columns,
                    body: exportData,
                    styles: {
                        fontSize: 8,
                        cellPadding: 2,
                        overflow: "linebreak"
                    },
                    columnStyles: {
                        count: { cellWidth: 12 },
                        prn: { cellWidth: 20 },
                        student_name: { cellWidth: 40 },
                        standard: { cellWidth: 15 },
                        division: { cellWidth: 15 },
                        route: { cellWidth: 25 },
                        vehicle: { cellWidth: 25 },
                        mapped_date: { cellWidth: 25 },
                        mapped_by: { cellWidth: 25 }
                    },
                    headStyles: {
                        fillColor: [0, 128, 0],
                        textColor: [255, 255, 255],
                        fontSize: 10
                    }
                });

                doc.save("LearnerRouteReport.pdf");
            } catch (err) {
                console.error("PDF generation error:", err);
                this.showSnackbar("error", "Failed to generate PDF");
            }
        },

        exportData() {
            try {
                const headersArr = this.headers;
                const headerTexts = headersArr.map(h => h.text);
                const exportData = this.filteredList.map((item, index) => {
                    const row = {};
                    headersArr.forEach(h => {
                        if (h.value === "count") {
                            row[h.text] = index + 1;
                        } else if (h.value === "mapped_date") {
                            row[h.text] = item[h.value]
                                ? new Date(item[h.value]).toLocaleDateString("en-GB")
                                : "-";
                        } else {
                            row[h.text] = (item[h.value] !== undefined && item[h.value] !== null) ? item[h.value] : "-";
                        }
                    });
                    return row;
                });

                import("xlsx").then(XLSX => {
                    const worksheet = XLSX.utils.json_to_sheet(exportData, { header: headerTexts });
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Learners");
                    XLSX.writeFile(workbook, "LearnerRouteReport.xlsx");
                });
            } catch (err) {
                console.error("Export error:", err);
                this.showSnackbar("error", "Failed to export Excel");
            }
        },

        async onload() {
            try {
                const res = await axios.post("/TransportLearnerAttendance/getAllLearnerRouteAndRouteList");
                if (res.data.msg === "200") {
                    this.route_list = res.data.route_list || [];
                    this.route_list_without_all = res.data.route_list.slice(1) || [];
                    this.vehicle_list = res.data.vehicle_list || [];
                    this.vehicle_list_without_all = this.vehicle_list.slice(1) || [];
                    this.learner_list = res.data.learner_list || [];
                } else {
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                }

                // Fetch all learner route data by default
                await this.getAllReport(true);
            } catch (error) {
                console.error("Onload error:", error);
                this.showSnackbar("error", "Failed to load data");
            }
        },

        async getAllReport(isInitialLoad = false) {
            this.loader = true;
            try {
                const data = isInitialLoad ? {} : { id: this.selected_route, vehicle_id: this.selected_vehicle };
                if (!isInitialLoad && (!this.selected_route || !this.selected_vehicle)) {
                    this.showSnackbar("error", "Please select both a route and a vehicle");
                    this.learner_list = [];
                    this.loader = false;
                    return;
                }
                const res = await axios.post("/TransportLearnerAttendance/getLearnerRoute", data);
                if (res.data.msg === "200") {
                    this.learner_list = res.data.learner_list || [];
                    if (this.learner_list.length === 0 && !isInitialLoad) {
                        this.showSnackbar("error", "No learners found for this route and vehicle");
                    }
                } else {
                    this.showSnackbar("error", res.data.msg || "Failed to fetch learners");
                    this.learner_list = [];
                }
            } catch (error) {
                console.error("Fetch error:", error);
                this.showSnackbar("error", "Failed to fetch learners");
                this.learner_list = [];
            } finally {
                this.loader = false;
            }
        },

        async saveLearnerRoute() {
            if (!this.selected_route_for_add_student) {
                this.showSnackbar("error", "Please Select Route..!");
                return;
            }
            if (!this.selected_vehicle_for_add_student) {
                this.showSnackbar("error", "Please Select Vehicle..!");
                return;
            }
            if (!this.addprn) {
                this.showSnackbar("error", "Please Enter PRN..!");
                return;
            }
            const data = {
                route: this.selected_route_for_add_student,
                vehicle: this.selected_vehicle_for_add_student,
                prn: this.addprn,
            };

            this.loader = true;
            try {
                const res = await axios.post("/TransportLearnerAttendance/saveLearnerRoute", data);
                if (res.data.msg === "200") {
                    this.dialogForAddStudents = false;
                    this.onload();
                    this.showSnackbar("green", "Map route to student successfully...!");
                } else {
                    this.showSnackbar("error", res.data.msg || "Something Went Wrong..!");
                }
            } catch (error) {
                console.error("Save error:", error);
                this.showSnackbar("error", "Something Went Wrong..!");
            } finally {
                this.loader = false;
            }
        }
    }
};
</script>

<style scoped>
@media (max-width: 600px) {
    .btn-text {
        display: none;
        padding: 0px;
    }
}
</style>